import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class FeaturedDiscussionAnnouncementNotification extends Notification {
  icon() {
    return 'fas fa-rss';
  }

  href() {
    const notification = this.attrs.notification;

    return app.route.discussion(notification.subject(), notification.content().postNumber);
  }

  content() {
    const discussion = this.attrs.notification.subject();
    return app.translator.trans('tanka-connector.forum.notifications.featured_discussion_announcement_text', { 
      title: discussion.title(),
      user: this.attrs.notification.fromUser() 
    });
  }
}
